
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import WhatYouCanCreate from './components/WhatYouCanCreate';
import HowItWorks from './components/HowItWorks';
import CitationIntegrity from './components/CitationIntegrity';
import AutomatedForms from './components/AutomatedForms';
import MobileFirst from './components/MobileFirst';
import PrivilegeProtected from './components/PrivilegeProtected';
import WhoItsFor from './components/WhoItsFor';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#09090b]">
      <Navigation />
      <Hero />
      <Problem />
      <Solution />
      <WhatYouCanCreate />
      <HowItWorks />
      <CitationIntegrity />
      <AutomatedForms />
      <MobileFirst />
      <PrivilegeProtected />
      <WhoItsFor />
      <Pricing />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
